import { Component, Input } from '@angular/core';
import { BaseControl } from '../base-control';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'time-picker-control',
  templateUrl: './time-picker-control.component.html',
  styleUrls: ['./time-picker-control.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: TimePickerControlComponent,
    multi: true
  }]
})
export class TimePickerControlComponent extends BaseControl {
  @Input() public use24HourFormat: boolean = false;
  
  constructor() {
    super();
  }

  ngOnInit() {
  }

  onWriteValue(value) {
    setTimeout(() => this.updateValue(), 100);
  }
}